export default {
  inserted(el, binding) {
    if (!binding.modifiers.empty || !el.value) {
      el.focus();
    }
  },
};
